import React from 'react'
import { Chip } from '@mui/material'

const MANAGEMENT_TYPE_CONFIG = {
  weg: { label: 'WEG', color: '#1a56db', bg: '#EFF6FF' },
  mv: { label: 'MV', color: '#065F46', bg: '#ECFDF5' },
  sev: { label: 'SEV', color: '#92400E', bg: '#FFFBEB' },
  privat: { label: 'Privat', color: '#6B21A8', bg: '#F5F3FF' },
}

const ASSEMBLY_STATUS_CONFIG = {
  planned: { label: 'Geplant', color: '#374151', bg: '#F9FAFB' },
  invited: { label: 'Eingeladen', color: '#1D4ED8', bg: '#EFF6FF' },
  held: { label: 'Durchgeführt', color: '#065F46', bg: '#ECFDF5' },
  minutes_completed: { label: 'Protokoll fertig', color: '#065F46', bg: '#DCFCE7' },
}

const ASSEMBLY_TYPE_CONFIG = {
  regular: { label: 'Ordentlich', color: '#374151', bg: '#F3F4F6' },
  extraordinary: { label: 'Außerordentlich', color: '#92400E', bg: '#FEF3C7' },
  circular_resolution: { label: 'Umlaufbeschluss', color: '#6B21A8', bg: '#F5F3FF' },
}

const RESOLUTION_STATUS_CONFIG = {
  accepted: { label: 'Angenommen', color: '#065F46', bg: '#DCFCE7' },
  rejected: { label: 'Abgelehnt', color: '#991B1B', bg: '#FEE2E2' },
  deferred: { label: 'Vertagt', color: '#92400E', bg: '#FEF3C7' },
  challenged: { label: 'Angefochten', color: '#C2410C', bg: '#FFF7ED' },
  final: { label: 'Bestandskräftig', color: '#1F2937', bg: '#F3F4F6' },
  void: { label: 'Ungültig', color: '#6B7280', bg: '#F9FAFB' },
}

const SPECIAL_LEVY_STATUS_CONFIG = {
  draft: { label: 'Entwurf', color: '#374151', bg: '#F9FAFB' },
  approved: { label: 'Freigegeben', color: '#065F46', bg: '#DCFCE7' },
  collecting: { label: 'In Einzug', color: '#1D4ED8', bg: '#EFF6FF' },
  completed: { label: 'Abgeschlossen', color: '#374151', bg: '#F3F4F6' },
}

const DISTRIBUTION_KEY_TYPE_CONFIG = {
  attribute_based: { label: 'Attribut', color: '#1D4ED8', bg: '#EFF6FF' },
  equal_per_unit: { label: 'Gleich', color: '#065F46', bg: '#ECFDF5' },
  composite: { label: 'Komposit', color: '#6B21A8', bg: '#F5F3FF' },
  direct: { label: 'Direkt', color: '#92400E', bg: '#FFFBEB' },
  custom: { label: 'Individuell', color: '#374151', bg: '#F3F4F6' },
}

const FISCAL_YEAR_STATUS_CONFIG = {
  open: { label: 'Offen', color: '#065F46', bg: '#DCFCE7' },
  closing: { label: 'Wird geschlossen', color: '#92400E', bg: '#FEF3C7' },
  closed: { label: 'Geschlossen', color: '#374151', bg: '#F3F4F6' },
}

const BUDGET_PLAN_STATUS_CONFIG = {
  draft: { label: 'Entwurf', color: '#374151', bg: '#F9FAFB' },
  approved: { label: 'Genehmigt', color: '#065F46', bg: '#DCFCE7' },
  closed: { label: 'Geschlossen', color: '#374151', bg: '#F3F4F6' },
}

const SETTLEMENT_STATUS_CONFIG = {
  draft: { label: 'Entwurf', color: '#374151', bg: '#F9FAFB' },
  calculated: { label: 'Berechnet', color: '#1D4ED8', bg: '#EFF6FF' },
  approved: { label: 'Genehmigt', color: '#065F46', bg: '#DCFCE7' },
  sent: { label: 'Versendet', color: '#6B21A8', bg: '#F5F3FF' },
  closed: { label: 'Geschlossen', color: '#374151', bg: '#F3F4F6' },
}

const PAYMENT_STATUS_CONFIG = {
  open: { label: 'Offen', color: '#92400E', bg: '#FEF3C7' },
  allocated: { label: 'Zugeordnet', color: '#065F46', bg: '#DCFCE7' },
  partially_allocated: { label: 'Teilweise zugeordnet', color: '#1D4ED8', bg: '#EFF6FF' },
  cancelled: { label: 'Storniert', color: '#991B1B', bg: '#FEE2E2' },
}

const PAYMENT_DIRECTION_CONFIG = {
  inbound: { label: 'Eingang', color: '#065F46', bg: '#DCFCE7' },
  outbound: { label: 'Ausgang', color: '#991B1B', bg: '#FEE2E2' },
}

const JOURNAL_ENTRY_STATUS_CONFIG = {
  draft: { label: 'Entwurf', color: '#374151', bg: '#F9FAFB' },
  posted: { label: 'Gebucht', color: '#065F46', bg: '#DCFCE7' },
  reversed: { label: 'Storniert', color: '#991B1B', bg: '#FEE2E2' },
}

const GENERATED_DOCUMENT_STATUS_CONFIG = {
  pending: { label: 'Ausstehend', color: '#374151', bg: '#F9FAFB' },
  generating: { label: 'Wird erstellt…', color: '#1D4ED8', bg: '#EFF6FF' },
  completed: { label: 'Fertig', color: '#065F46', bg: '#DCFCE7' },
  failed: { label: 'Fehlgeschlagen', color: '#991B1B', bg: '#FEE2E2' },
}

const INVOICE_STATUS_CONFIG = {
  draft: { label: 'Entwurf', color: '#374151', bg: '#F9FAFB' },
  submitted: { label: 'Eingereicht', color: '#1D4ED8', bg: '#EFF6FF' },
  under_review: { label: 'In Prüfung', color: '#92400E', bg: '#FEF3C7' },
  approved: { label: 'Freigegeben', color: '#065F46', bg: '#DCFCE7' },
  payment_initiated: { label: 'Zahlung initiiert', color: '#6B21A8', bg: '#F5F3FF' },
  paid: { label: 'Bezahlt', color: '#065F46', bg: '#ECFDF5' },
  rejected: { label: 'Abgelehnt', color: '#991B1B', bg: '#FEE2E2' },
  cancelled: { label: 'Storniert', color: '#6B7280', bg: '#F3F4F6' },
}

const CONFIG_MAP = {
  management_type: MANAGEMENT_TYPE_CONFIG,
  assembly_status: ASSEMBLY_STATUS_CONFIG,
  assembly_type: ASSEMBLY_TYPE_CONFIG,
  resolution_status: RESOLUTION_STATUS_CONFIG,
  special_levy_status: SPECIAL_LEVY_STATUS_CONFIG,
  distribution_key_type: DISTRIBUTION_KEY_TYPE_CONFIG,
  fiscal_year_status: FISCAL_YEAR_STATUS_CONFIG,
  budget_plan_status: BUDGET_PLAN_STATUS_CONFIG,
  settlement_status: SETTLEMENT_STATUS_CONFIG,
  payment_status: PAYMENT_STATUS_CONFIG,
  payment_direction: PAYMENT_DIRECTION_CONFIG,
  journal_entry_status: JOURNAL_ENTRY_STATUS_CONFIG,
  generated_document_status: GENERATED_DOCUMENT_STATUS_CONFIG,
  invoice_status: INVOICE_STATUS_CONFIG,
}

export default function StatusBadge({ type, value, size = 'small' }) {
  const config = CONFIG_MAP[type]?.[value]
  if (!config) return null

  return (
    <Chip
      label={config.label}
      size={size}
      sx={{
        color: config.color,
        backgroundColor: config.bg,
        fontWeight: 500,
        fontSize: size === 'small' ? '0.75rem' : '0.875rem',
        height: size === 'small' ? 22 : 28,
        border: 'none',
      }}
    />
  )
}
